import React from 'react';
import axios, { AxiosResponse } from 'axios';
import { ArrowDownIcon } from '@kursk/components/ui/icons';
import { IframeEventCard } from "./IframeEventCard/IframeEventCard";
import { api } from '@common/urls';
import type { IEvent } from "@common/redux/types/event";
import styles from './IframeEvents.module.scss';

type TProps = {
  items: IEvent[];
  total: number;
  params: EventsRequestParams
}

type EventsRequestParams = {
  start: number;
  organizationSysName: string;
  withTickets: boolean;
  sort: string;
  limit: number;
  offset: number;
};


type EventsResponse = {
  events: IEvent[];
  total: number;
}

const FIRST_PAGE = 1;
const getFilteredEvents = (events: IEvent[]) => events.filter(event => event.poolAvailable)

export function IframeEvents({ items = [], total, params }: TProps) {
  const [allEvents, setAllEvents] = React.useState(items);
  const [filteredEvents, setFilteredEvents] = React.useState(getFilteredEvents(items));
  const [totalEvents, setTotalEvents] = React.useState(total);
  const [isLoading, setIsLoading] = React.useState(false);
  const [page, setPage] = React.useState(FIRST_PAGE);

  React.useEffect(() => {
    const expectedCount = params.limit * page;
    const missingEventsCount = expectedCount - filteredEvents.length;
    const allEventsCount = allEvents.length;

    if (missingEventsCount > 0 
      && allEventsCount < totalEvents 
      && !isLoading) {
      loadMore(missingEventsCount);
    }
  }, [page, filteredEvents.length, allEvents.length, totalEvents, isLoading]);

  const nextPage = () => setPage(prev => prev + 1);

  const loadMore = async (count: number = params.limit) => {
    setIsLoading(true);
    try {
      const requestParams: EventsRequestParams = {
        ...params,
        offset: allEvents.length,
        limit: count,
      };

      const eventsResponse: AxiosResponse<EventsResponse, EventsRequestParams> = await axios.get<EventsResponse>(
        api.events.get(),
        { params: requestParams }
      );

      const fetched = eventsResponse.data.events;

      if (fetched.length === 0) {
        setTotalEvents(allEvents.length);
        return;
      }

      const newAllEvents = [...allEvents, ...fetched];
      const newFilteredEvents = [
        ...filteredEvents,
        ...getFilteredEvents(fetched),
      ];

      setAllEvents(newAllEvents);
      setFilteredEvents(newFilteredEvents);
      setTotalEvents(eventsResponse.data.total);

    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={styles.page}>
      <div className={styles.container}>
        <h2 className={styles.title}>Афиша</h2>
        <div className={styles.list}>
          {filteredEvents.map(item => {
            return <IframeEventCard key={item._id} event={item} />
          })}
        </div>
      </div>
      {allEvents.length < totalEvents && 
        <div className={styles.buttonContainer}>
          <button 
            className={styles.button} 
            onClick={nextPage}
            disabled={isLoading}
          >
            Показать еще 
            <ArrowDownIcon width={12} height={5}/>
          </button>
        </div>
      }
    </div>
  );
}